

































































import { defineComponent, ref } from "@vue/composition-api";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { loginToken } from "@/lib/loginHelpers";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseConfirm from "@/components/BaseConfirm";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "LinkedUsersModal",
  components: { BaseButton, BaseIcon, BaseConfirm, BaseAvatar, BaseSpinner },
  props: {
    show: { type: Boolean, default: false },
  },
  setup(_, { root }) {
    const { authUser } = useAuthUser();
    const showAddUserConfirm = ref(false);
    const loading = ref(false);
    const loginProcessingId = ref("");
    const linkedUsers = ref<UserPublicData[]>([]);
    const addUser = async (showLogin: boolean) => {
      emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, { showLogin, isSwitch: true });
    };

    const USER_FRAGMENT: FragmentFields<UserPublicData> = [
      "id",
      "screenName",
      "username",
      "role",
      { onlineStatus: ["isOnline"] },
      { avatar: ["urlPart", "uuid", "updateTime", "metadata"] },
    ];

    const getLinkedUsers = async () => {
      try {
        loading.value = true;
        linkedUsers.value = await providers.LinkedUsersProvider.search(USER_FRAGMENT);
      } finally {
        loading.value = false;
      }
    };

    const loginAsUser = async (userId: string) => {
      if (userId === authUser.value?.id || loginProcessingId.value) return;
      loginProcessingId.value = userId;
      const token = await providers.LoginProvider.longLiveTokenByUser(userId);
      await loginToken(token);
      root.$router.push({ name: "home" }).then(() => location.reload());
    };

    getLinkedUsers();

    return {
      showAddUserConfirm,
      authUser,
      loading,
      linkedUsers,
      addUser,
      loginAsUser,
      loginProcessingId,
    };
  },
});
